/**
 * 全局混合
 */
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { PostRes } from '@/store/pages/report/index.d';
import { dateFormate, fetchReportAfterRecovery } from '@/utils/report';
import CommonMixin from '@/mixins/common.mixin';
const Report = namespace('report');

@Component
export default class Level extends CommonMixin {
  @Report.Action('getDailyIncomeReport') private getDailyIncomeReport: any;
  @Report.Action('exportDailyIncomeReport') private exportDailyIncomeReport: any;
  @Report.Action('recoveryDailyIncomeReport') private recoveryDailyIncomeReport: any;
  public exportReport() {
    this.exportDailyIncomeReport({
      reportId: this.reportId, 
      level: this.level, 
      start_date: dateFormate(this.start),  
      end_date: dateFormate(this.end), 
      store_group_id: this.store_group_id
    });
  }
  public recovery() {
    this.recoveryDailyIncomeReport({reportId: this.reportId, level: this.level}).then((res: PostRes) => {
      this.fetchReport();
    });
  }
  public fetchReport() {
    fetchReportAfterRecovery(this, 'getDailyIncomeReport');
  }
}
